import { FC } from "react";
import { Sparkles } from "lucide-react";
import { MessagePrimitive } from "@assistant-ui/react";
import { cn } from "@/lib/utils";
import { TOOL_PREFIX } from "@/src/pages/study/hooks/useChatRuntime";
import { HIGHLIGHT_CONFIG } from "@/src/pages/study/components/layout/highlights/highlights";

export const IntentAwareText: FC<{ text: string }> = ({ text }) => {
  const isToolCall = text.startsWith(TOOL_PREFIX);

  if (isToolCall) {
    const [header] = text.split("\n");
    const headerWithoutPrefix = header.replace(`${TOOL_PREFIX}:`, "");
    const intent = headerWithoutPrefix.slice(
      0,
      headerWithoutPrefix.indexOf(" ")
    );

    const highlight = HIGHLIGHT_CONFIG.find(
      (config) => config.label === intent
    );

    const content = headerWithoutPrefix.slice(
      headerWithoutPrefix.indexOf(" ", headerWithoutPrefix.indexOf(" ") + 1) + 1
    );

    return (
      <div
        className={cn(
          "relative rounded-xl border-2 overflow-hidden",
          "shadow-sm hover:shadow-md transition-shadow duration-200",
          "bg-theme-0",
          highlight?.color.border || "border-emerald-200",
          "animate-in fade-in slide-in-from-bottom-1"
        )}
      >
        {/* Intent header - more prominent */}
        <div
          className={cn(
            "flex items-center gap-2 px-4 py-2.5 border-b",
            highlight?.color.border || "border-emerald-200",
            highlight?.color.bgLight
          )}
        >
          <div
            className={cn(
              "flex h-6 w-6 items-center justify-center rounded-md",
              highlight?.color.bgDark
            )}
          >
            <Sparkles className="h-3.5 w-3.5 text-white" />
          </div>
          <span
            className={cn("text-[13px] font-bold tracking-tight text-theme-0")}
          >
            Generate {intent}
          </span>
        </div>

        {/* Content */}

        <div className="px-4 py-3">
          <div className="text-[13px] leading-relaxed text-theme-0 font-medium">
            {content || "All Topics"}
          </div>
        </div>
      </div>
    );
  }

  // Normal user message bubble
  return (
    <div
      className={cn(
        "rounded-2xl bg-theme-1 border-2 border-theme",
        "px-4 py-3.5",
        "text-[13px] leading-relaxed text-theme-0 font-medium",
        "transition-all duration-200",
        "animate-in fade-in slide-in-from-bottom-1"
      )}
    >
      <MessagePrimitive.Parts />
    </div>
  );
};
